
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m12 16.25c1.1833 0 2.1875-.4125 3.0125-1.2375s1.2375-1.8292 1.2375-3.0125-.4125-2.1875-1.2375-3.0125-1.8292-1.2375-3.0125-1.2375-2.1875.4125-3.0125 1.2375-1.2375 1.8292-1.2375 3.0125.4125 2.1875 1.2375 3.0125 1.8292 1.2375 3.0125 1.2375zm0-1.45c-.7833 0-1.4458-.2708-1.9875-.8125-.54167-.5417-.8125-1.2042-.8125-1.9875s.27083-1.4458.8125-1.9875c.5417-.54167 1.2042-.8125 1.9875-.8125s1.4458.27083 1.9875.8125c.5417.5417.8125 1.2042.8125 1.9875s-.2708 1.4458-.8125 1.9875-1.2042.8125-1.9875.8125zm0 4.7c-2.43333 0-4.63333-.6917-6.6-2.075s-3.43333-3.1917-4.4-5.425c.96667-2.23333 2.43333-4.04167 4.4-5.425s4.16667-2.075 6.6-2.075c2.4333 0 4.6333.69167 6.6 2.075s3.4333 3.19167 4.4 5.425c-.9667 2.2333-2.4333 4.0417-4.4 5.425s-4.1667 2.075-6.6 2.075zm0-1.5c2.0167 0 3.8708-.5458 5.5625-1.6375s2.9792-2.5458 3.8625-4.3625c-.8833-1.8167-2.1708-3.27083-3.8625-4.3625s-3.5458-1.6375-5.5625-1.6375c-2.01667 0-3.87083.54583-5.5625 1.6375s-2.9875 2.5458-3.8875 4.3625c.9 1.8167 2.19583 3.2708 3.8875 4.3625s3.54583 1.6375 5.5625 1.6375z","fill":"#4a3428"}})])
          )
        }
      }
    